import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper" }

import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import GreetingsBlockContentHolder from "@/components/MainPage/MobileVersion/GreetingsBlock/ContentHolder.vue";
import MobileRegisterButton from "@/components/MainPage/MobileVersion/RegisterButton.vue";
import PreorderInfoBlockContentHolder from "@/components/MainPage/MobileVersion/PreorderInfoBlock/ContentHolder.vue";
import TestDescriptionBlockContentHolder
    from "@/components/MainPage/MobileVersion/TestDescriptionBlock/ContentHolder.vue";
import ReferralProgramBlockContentHolder
    from "@/components/MainPage/MobileVersion/ReferralProgramBlock/ContentHolder.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'MainPageMobileVersion',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ScoutsLogo),
      _createVNode(GreetingsBlockContentHolder),
      _createVNode(MobileRegisterButton),
      _createVNode(PreorderInfoBlockContentHolder),
      _createVNode(TestDescriptionBlockContentHolder),
      _createVNode(MobileRegisterButton),
      _createVNode(ReferralProgramBlockContentHolder)
    ])
  ]))
}
}

})